import { useEffect, useState } from 'react';
import useDevices from 'containers/Call/hooks/useDevices';
import { useCameraTest } from '../hooks/useCameraTest';
import { Buttons, Card } from 'components/Card/Card';
import { languages } from 'locales/languages';
import { Button } from 'components/Button';
import { cdn } from 'core/cdn';

const defaultVideoInputDeviceId = 'default';

const VideoTest = ({onAccept, onError}) => {
  const [loading, setLoading] = useState<boolean>(true);
  const videoInputDevices = useDevices()?.filter((device) => device.kind === 'videoinput' && device.deviceId === defaultVideoInputDeviceId)?.[0];
  const { videoElementRef, startVideoTest, stopVideoTest, videoTestError } = useCameraTest();

  useEffect(() => {
    startVideoTest(videoInputDevices?.deviceId);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Card title={languages.doYouSeeYourselfOnScreen}>
      <div className='flex-center'>
        <video width={480} height={360} poster={cdn('/loaders/gimmick-video.gif')} preload='auto' autoPlay onLoadedData={() => setLoading(false)} playsInline ref={videoElementRef}>
          <p>
            {languages.yourCameraDoesNotWork}
          </p>
        </video>
      </div>
      <div className='flex-center' style={{marginTop: '50px'}}>
        <Buttons>
          <Button loading={loading} type='default' style={{ width: '350px' }} onClick={() => {
              console.error(`user raised an error with the video device`, {
                route: 'device:VideoTest'
              })
              stopVideoTest();
              onError(`user raised an error with the ${videoTestError}`);
              }}>
            {languages.no}
          </Button>
          <Button loading={loading} type="primary" style={{ width: '350px' }} onClick={() => {
            stopVideoTest();
            onAccept();
            }}>
             {languages.yes}
          </Button>
        </Buttons>
      </div>
    </Card>
  )


}


export default VideoTest;